export function toursCarousel() {
    $(".tours-carousel .carousel").slick({
        speed: 300,
        slidesToShow: 4,
        slidesToScroll: 1,
        dots: true,
        prevArrow: false,
        nextArrow: false,
        infinite: false,
        responsive: [
            {
                breakpoint: 9999,
                settings: {
                    slidesToShow: 4,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                    dots: true,
                    arrows: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1.75,
                    dots: false,
                    arrows: false
                }
            }
        ]
    });

    $('.tours-carousel .prev').click(function () {
        $(this).parent().find('.carousel').slick('slickPrev');
    });
    $('.tours-carousel .next').click(function () {
        $(this).parent().find('.carousel').slick('slickNext');
    });
}



// WEBPACK FOOTER //
// ./c:/Projects/UB/unlimitedbiking.com/wp-content/themes/unlimitedbiking/slice/assets/js/modules/toursCarousel.js